export function inr(n, dec = 2) {
  const v = Number(n || 0);
  const s = "₹" + Math.abs(v).toLocaleString("en-IN", { minimumFractionDigits: dec, maximumFractionDigits: dec });
  return v < 0 && s !== "₹" + (0).toFixed(dec) ? "−" + s : s;
}

export function inr0(n) {
  const v = Math.round(Number(n || 0));
  return (v < 0 ? "−₹" : "₹") + Math.abs(v).toLocaleString("en-IN", { maximumFractionDigits: 0 });
}

export function fmtDate(s) {
  if (!s) return "—";
  try {
    return new Date(s).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return s;
  }
}

export function toCSV(columns, rows) {
  const head = columns.join(",");
  const body = rows
    .map((r) => columns.map((c) => `"${String(r[c] ?? "").replace(/"/g, '""')}"`).join(","))
    .join("\n");
  return head + "\n" + body;
}

export function downloadCSV(filename, columns, rows) {
  const csv = toCSV(columns, rows);
  const blob = new Blob([csv], { type: "text/csv" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
